import { useState, useEffect } from "react";
import { disposables as o } from "../utils/disposables.js";
function p() {
  let [e] = useState(o);
  return useEffect(() => () => e.dispose(), [e]), e;
}
export {
  p as useDisposables
};
